import React from 'react';
import PropTypes from 'prop-types';
import {
  COUNTRY_OPTIONS,
  getStateOptions,
  stateFieldLabel
} from 'components/contacts/companies/country_state_list';
import { Col, Row } from 'react-bootstrap';

export default function AddressFields({ address, showAddress, onChange }) {
  const countryId = address.countryId || 1;

  const stateOptions = getStateOptions(countryId || 1);

  if (!showAddress) return null;

  return (
    <React.Fragment>
      <Row>
        <Col md={6}>
          <label className="w-100 form-group">
            Address Name
            <input
              className="form-control mt-2 fw-normal"
              type="text"
              value={address.label || ''}
              onChange={e => onChange(e.target.value, 'label')}
            />
          </label>
        </Col>

        <Col md={6}>
          <label className="w-100 form-group">
            Country
            <select
              className="form-control mt-2 fw-normal"
              value={countryId.toString()}
              onChange={e => onChange(e.target.value, 'countryId')}
            >
              {COUNTRY_OPTIONS.map(countryOption => (
                <option key={countryOption[0]} value={countryOption[1]}>{countryOption[0]}</option>
              ))}
            </select>
          </label>
        </Col>
      </Row>

      {address.countryId === 0 && (
        <label className="w-100 form-group">
          Country Name Override
          <input
            className="form-control mt-2 fw-normal"
            type="text"
            value={address.countryNameOverride || ''}
            onChange={e => onChange(e.target.value, 'countryNameOverride')}
          />
        </label>
      )}

      <Row>
        <Col md={6}>
          <label className="w-100 form-group">
            Address Line 1
            <input
              className="form-control mt-2 fw-normal"
              type="text"
              value={address.addressOne || ''}
              onChange={e => onChange(e.target.value, 'addressOne')}
            />
          </label>
        </Col>

        <Col md={6}>
          <label className="w-100 form-group">
            Address Line 2
            <input
              className="form-control mt-2 fw-normal"
              type="text"
              value={address.addressTwo || ''}
              onChange={e => onChange(e.target.value, 'addressTwo')}
            />
          </label>
        </Col>
      </Row>

      <Row>
        <Col md={4}>
          <label className="w-100 form-group d-block">
            City
            <input
              className="form-control mt-2 fw-normal"
              type="text"
              value={address.city || ''}
              onChange={e => onChange(e.target.value, 'city')}
            />
          </label>
        </Col>

        <Col md={4}>
          {stateOptions.length > 0 ? (
            <label className="w-100 form-group d-block">
              {stateFieldLabel(countryId.toString())}
              <select
                className="form-control mt-2 fw-normal"
                value={address.state || stateOptions[0][1]}
                onChange={e => onChange(e.target.value, 'state')}
              >
                {stateOptions.map(stateOption => (
                  <option key={stateOption[1]} value={stateOption[1]}>{stateOption[0]}</option>
                ))}
              </select>
            </label>
          ) : (
            <label className="w-100 form-group d-block">
              {stateFieldLabel(countryId.toString())}
              <input
                className="form-control mt-2 fw-normal"
                type="text"
                value={address.state || ''}
                onChange={e => onChange(e.target.value, 'state')}
              />
            </label>
          )}
        </Col>

        <Col md={4}>
          <label className="w-100 form-group">
            Zip
            <input
              className="form-control mt-2 fw-normal"
              type="text"
              value={address.zip || ''}
              onChange={e => onChange(e.target.value, 'zip')}
            />
          </label>
        </Col>
      </Row>
    </React.Fragment>
  );
}

AddressFields.propTypes = {
  address: PropTypes.object.isRequired,
  showAddress: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};
